export const addOnsDescription: { [key: string]: string } = {
  "flight-tracking": "Keep your plans on track with live flight updates for your clients & drivers.",
};

export const addOnsIcon: { [key: string]: string } = {
  "flight-tracking": "flight-tracking",
  "preferred-driver": "preferred-driver",
};